import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import EigeneAuftraegeListe from '../eigeneauftraege/EigeneAuftraegeListe';
import AGLieferungenListe from '../auftraggeber/AGLieferungenListe';

export default function LandingPageAuftraggeber() {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [view, setView] = useState<string>("auftraege");

    return (
        <>
            <div className="container">


                <div style={{ display: "flex" }}>

                    <button onClick={() => setView("auftraege")}
                        style={{ marginBottom: "20px", marginLeft: "10px", alignItems: "end" }}
                        className={(view === "auftraege") ? "btn btn-primary" : "btn btn-outline-primary"}
                    >
                        <i className='bi bi-list'></i>&nbsp;Eigene Aufträge
                    </button>

                    {/*<button onClick={() => setView("lieferungen")}
                        style={{ marginBottom: "20px", marginLeft: "10px", alignItems: "end" }}
                        className={(view === "lieferungen") ? "btn btn-primary" : "btn btn-outline-primary"}
                    >
                        <i className='bi bi-truck'></i>&nbsp;Lieferungen
                    </button>*/}

                    <button onClick={() => navigate("/neuerauftrag")}
                        style={{ marginBottom: "20px", marginLeft: "auto", alignItems: "end" }}
                        className=' btn btn-success'
                    >
                        <i className='bi bi-plus'></i>&nbsp;Neuen Auftrag anlegen
                    </button>

                </div>

                {view === "auftraege" &&
                    <EigeneAuftraegeListe statusChanged={() => { }} />
                }

                {view === "lieferungen" &&
                    <AGLieferungenListe />
                }
            </div>

        </>
    );
}
